module.exports = __webpack_public_path__ + "static/media/pm-creative.b6b8571e.jpg";